const formatRepoName = (repoName = "") =>
  repoName
    .replace(/[-_]+/g, " ")
    .split(" ")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

const formatCompactNumber = (value = 0) =>
  new Intl.NumberFormat("en-US", {
    notation: "compact",
    maximumFractionDigits: 1,
  }).format(value);

const languageColorMap = {
  JavaScript: "#facc15",
  TypeScript: "#38bdf8",
  Python: "#4ade80",
  Go: "#22d3ee",
  Rust: "#fb923c",
  HTML: "#f97316",
  CSS: "#818cf8",
  "C++": "#06b6d4",
  C: "#14b8a6",
};

const getLanguageColor = (language) => languageColorMap[language] || "#94a3b8";

export { formatRepoName, formatCompactNumber, getLanguageColor };
